import { callApi } from '@local_modules/generic/fetch'
import { fillString } from '@local_modules/generic/string-template'

export async function disassociateEntity (appAccountId, entityId) {
  const urlEndpoint = '/api/app-account-organisation/:appAccountId/:accountingOrganisationId/disassociate'

  const url = fillString(urlEndpoint, {
    appAccountId,
    accountingOrganisationId: entityId
  })

  const response = await callApi(url, null, {
    method: 'DELETE'
  })

  return response
}
